export default {"src":"/_next/static/media/support-material.9deff27a.svg","height":73,"width":72};